var _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdTime03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTime03",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#b5d36d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(23 56.5)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime03);
export default __webpack_public_path__ + "static/media/prodTime03.0a56f5b2d2592e33e3e3990255052035.svg";
export { ForwardRef as ReactComponent };